import React from "react";
import { format } from "date-fns";

import { CalendarAlbum } from "../../api/albums";
import "./Album.scss";

export type AlbumProps = CalendarAlbum;

export function Album(album: AlbumProps) {
    return (
        <a
          className="album"
          href={album.album_link}
          target="_blank"
          rel="noreferrer"
        >
            <img src={album.cover_image_url} alt={album.album_name} />
            <span className="date">
                {format(new Date(album.calendar_date), "d")}
            </span>
            <div className="details">
                <p>
                    <b>{album.album_name}</b>
                    <br />
                    <span className="artist">{album.artist_name}</span>
                </p>
                <span className="recommender">
                    from {album.recommender_name}
                </span>
            </div>
        </a>
    );
}

export function AlbumEmptyState() {
    return <div className="album-empty-state" />;
}
